import { render, staticRenderFns } from "./PaginacaoComQuantidade.vue?vue&type=template&id=3d1f1549&scoped=true"
import script from "./PaginacaoComQuantidade.vue?vue&type=script&lang=js"
export * from "./PaginacaoComQuantidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f1549",
  null
  
)

export default component.exports